import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'
import { useTimeoutFn } from 'react-use'
import { ContextShell } from '../../../modules/context'

const PATHS_TO_NOT_REDIRECT = [
  '/login',
  '/logout',
  '/reset-password',
  '/cancellation-survey',
  '/paywall/modal'
]

export const useRedirectToLoginOnAuthenticationTimeout = (): void => {
  const { pathname, asPath } = useRouter()
  const { userToken, loadingUserData } = useContext(ContextShell)

  const [isTokenTimeoutReady, cancelTokenTimeout, resetTokenTimeout] =
    useTimeoutFn(() => {
      if (loadingUserData) {
        resetTokenTimeout()
        return
      }

      if (!userToken && !PATHS_TO_NOT_REDIRECT.includes(pathname)) {
        window.location.href = `/login?redirect=${asPath}`
      }
    }, 5000)

  useEffect(() => {
    const isTokenTimeoutPending = isTokenTimeoutReady() === false
    if (userToken && isTokenTimeoutPending) {
      cancelTokenTimeout()
    }
  }, [cancelTokenTimeout, isTokenTimeoutReady, userToken])
}
